import { assign, createMachine } from 'xstate';

export enum GenerateShowStatusEnum {
  Unknown = 'Unknown',
  Generating = 'Generating',
  Generated = 'Generated',
  Error = 'Error',
}

export const audioItemGenerateStatusMachine = createMachine({
  id: 'generation',
  initial: GenerateShowStatusEnum.Unknown,
  context: {
    progressPercentage: 0,
  },
  states: {
    [GenerateShowStatusEnum.Unknown]: {
      on: {
        GENERATING: {
          target: GenerateShowStatusEnum.Generating,
          actions: assign({
            progressPercentage: 0,
          }),
        },
        GENERATED: GenerateShowStatusEnum.Generated,
        ERROR: GenerateShowStatusEnum.Error,
      },
    },
    [GenerateShowStatusEnum.Generating]: {
      on: {
        UPDATE_PROGRESS: {
          actions: assign({
            progressPercentage: ({ context, event }) => {
              return event?.progressPercentage;
            },
          }),
        },
        GENERATED: GenerateShowStatusEnum.Generated,
        ERROR: GenerateShowStatusEnum.Error,
      },
    },
    [GenerateShowStatusEnum.Generated]: {
      type: 'final',
    },
    [GenerateShowStatusEnum.Error]: {
      type: 'final',
    },
  },
});
